const blogList = [
  {
    date: "20 Apr",
    image: "assets/images/blog/01.jpg",
    category: ["Cloth", "Fashion"],
    title: "Spring summer fashion trends new high collection",
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: "15 Mar",
    image: "assets/images/blog/02.jpg",
    category: ["Cloth", "Fashion"],
    title: "When it’s Winter outdoors gifts but you feel like ekocart",
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: "13 Apr",
    image: "assets/images/blog/03.jpg",
    category: ["Cloth", "Fashion"],
    title: "Whatever the will make it special For You Every",
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: "20 Apr",
    image: "assets/images/electronic/blog/01.jpg",
    category: ["Electronic", "Accessories"],
    title: "Spring summer Electronic trends new high collection ",
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: "15 Mar",
    image: "assets/images/electronic/blog/02.jpg",
    category: ["Electronic", "Accessories"],
    title: "When it’s Winter outdoors Electronic but you feel like ekocart",
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: "13 Apr",
    image: "assets/images/electronic/blog/03.jpg",
    category: ["Electronic", "Accessories"],
    title: "Whatever the will make it special For You Every electronic",
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: '20 Apr',
    image: 'assets/images/furniture/blog/01.jpg',
    category: ['Chair', 'Modern'],
    title: 'Introducing Ekocart Modern Home Furniture',
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: '15 Mar',
    image: 'assets/images/furniture/blog/02.jpg',
    category: ['Chair', 'Modern'],
    title: 'When it’s Winter outdoors gifts but you feel like ekocart furniture',
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: '13 Apr',
    image: 'assets/images/furniture/blog/03.jpg',
    category: ['Chair', 'Modern'],
    title: 'Whatever the will make it special For You Every furniture',
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: '20 Apr',
    image: 'assets/images/kids/blog/01.jpg',
    category: ["Cloth", "Fashion", 'Kids'],
    title: 'Spring summer fashion trends new high collection furniture',
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: '15 Mar',
    image: 'assets/images/kids/blog/02.jpg',
    category: ["Cloth", "Fashion", 'Kids'],
    title: 'When it’s Winter kids gifts but you feel like ekocart',
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
  {
    date: '13 Apr',
    image: 'assets/images/kids/blog/03.jpg',
    category: ["Cloth", "Fashion", 'Kids'],
    title: 'Whatever the will make it special For You Every kids',
    content: "lights dominion divide years for fourth have don't stars is that saying. serspiciatis unde omnis iste natus error. The expert team at Brightscout specializes in building innovative technology solutions for enterprises."
  },
];

export default blogList;
